var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "padding" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "經銷商" } },
                [
                  _c("selectCompany", {
                    attrs: { id: _vm.company_id },
                    on: {
                      "update:id": function ($event) {
                        _vm.company_id = $event
                      },
                      onSelect: _vm.onSelectCompany,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.invoices.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.invoices.rows, "row-class-name": _vm.statusClass },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "AssetNo", label: "機台編號" },
          }),
          _c("el-table-column", {
            attrs: { prop: "OrderNo", label: "訂單編號", width: "370" },
          }),
          _c("el-table-column", {
            attrs: { label: "開立時間", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateTimeFilter")(scope.row.updated_at)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "Period", label: "期別", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { label: "發票號碼", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.Front) +
                        "-" +
                        _vm._s(scope.row.Number) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "開立類型", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tag", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("invoiceTypeFilter")(
                              scope.row.detail.invoiceType
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "開立狀態", width: "100", prop: "Status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.Status ? "success" : "danger",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.Status ? "未開立" : "已開立") +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "動作", width: "100" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return scope.row.detail
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                round: "",
                                type: "primary",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("明細")]
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.invoices.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "發票明細",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("h3", [_vm._v("品名: " + _vm._s(_vm.invoiceDetail.product_name))]),
          _c("h3", [_vm._v("單價: " + _vm._s(_vm.invoiceDetail.unit_price))]),
          _c("h3", [
            _vm._v(
              "支付方式: " +
                _vm._s(_vm._f("paytypeFilter")(_vm.invoiceDetail.pay_type))
            ),
          ]),
          _c("h3", [
            _vm._v("交易時間: " + _vm._s(_vm.invoiceDetail.sale_time)),
          ]),
          _c("h3", [
            _vm._v(
              "開立方式: " +
                _vm._s(
                  _vm._f("invoiceTypeFilter")(_vm.invoiceDetail.invoice_type)
                )
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }